export default __webpack_public_path__ + "static/media/girls.bb3609b7.JPG";